
        <ng-container *ngIf="confirm.state$ | async as dialog">
            <div class="fixed inset-0 z-[200] flex items-end justify-center bg-black/60 p-4 sm:items-center" (click)="cancel()">
                <div
                    class="w-full max-w-md rounded-3xl border border-[color:var(--border)] bg-[color:var(--card)] p-6 shadow-2xl"
                    (click)="$event.stopPropagation()"
                    role="dialog"
                    aria-modal="true"
                >
                    <div class="flex items-start justify-between gap-4">
                        <div class="min-w-0">
                            <p class="text-lg font-semibold text-[color:var(--foreground)]">{{ dialog.title }}</p>
                            <p class="mt-1 whitespace-pre-line text-sm text-[color:var(--muted-foreground)]">{{ dialog.message }}</p>
                        </div>
                        <button
                            type="button"
                            class="rounded-full p-2 text-[color:var(--muted-foreground)] transition hover:bg-[color:var(--hover)]"
                            (click)="cancel($event)"
                        >
                            <lucide-icon name="x" class="h-4 w-4"></lucide-icon>
                        </button>
                    </div>

                    <div class="mt-6 flex flex-col gap-2 sm:flex-row sm:justify-end">
                        <button
                            type="button"
                            class="inline-flex items-center justify-center rounded-lg border border-[color:var(--border)] bg-[color:var(--card)] px-4 py-2 text-sm font-semibold text-[color:var(--foreground)] transition hover:bg-[color:var(--hover)]"
                            (click)="cancel()"
                        >
                            {{ dialog.cancelText }}
                        </button>
                        <button
                            type="button"
                            class="inline-flex items-center justify-center rounded-lg px-4 py-2 text-sm font-semibold text-white transition"
                            [ngClass]="dialog.tone === 'danger' ? 'bg-red-600 hover:bg-red-500' : 'bg-[color:var(--primary)] hover:bg-[color:var(--primary-hover)]'"
                            (click)="accept()"
                        >
                            {{ dialog.confirmText }}
                        </button>
                    </div>
                </div>
            </div>
        </ng-container>
    
